import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axiosInstance';

export default function ContactUs() {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        // Fetch contact entries from the API
        const response = await axiosInstance.get('/api/products/contact');
        setContacts(response.data);
      } catch (error) {
        console.error('Error fetching contacts:', error);
      }
    };

    fetchContacts();
  }, []);

  return (
    <div className="container mx-auto mt-8">
      <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr>
              <th className="py-2 px-4 border-b md:table-cell">Name</th>
              <th className="py-2 px-4 border-b md:table-cell">Email</th>
              <th className="py-2 px-4 border-b md:table-cell">Phone</th>
              <th className="py-2 px-4 border-b md:table-cell">Message</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((contact) => (
              <tr key={contact._id} className="hover:bg-gray-100">
                <td className="py-2 px-4 border-b md:table-cell">{contact.name}</td>
                <td className="py-2 px-4 border-b md:table-cell">{contact.email}</td>
                <td className="py-2 px-4 border-b md:table-cell">{contact.phone}</td>
                <td className="py-2 px-4 border-b md:table-cell">{contact.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
